/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S5_HeadingInputs */

const tr_onbilgi_s5_heading = /** @type {(inputs: Onbilgi_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. İfa ve Aktivasyon`)
};

const en_onbilgi_s5_heading = /** @type {(inputs: Onbilgi_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Performance and Activation`)
};

const de_onbilgi_s5_heading = /** @type {(inputs: Onbilgi_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Erfüllung und Aktivierung`)
};

const ru_onbilgi_s5_heading = /** @type {(inputs: Onbilgi_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Исполнение и активация`)
};

/**
* | output |
* | --- |
* | "5. Performance and Activation" |
*
* @param {Onbilgi_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s5_heading = /** @type {((inputs?: Onbilgi_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s5_heading(inputs)
	if (locale === "de") return de_onbilgi_s5_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s5_heading(inputs)
	return tr_onbilgi_s5_heading(inputs)
});